import React, { FC, useEffect, useState } from "react";
import classes from "./MediaRecommendations.module.css";
import { motion } from "framer-motion";
import MovieCard from "../Drag-Cards/MovieCard";

type MediaRecommendationsProps = {
  mediaDetails: any;
  windowWidth: number;
  type: "movies" | "series";
};

const MediaRecommendations: FC<MediaRecommendationsProps> = ({
  mediaDetails,
  windowWidth,
  type,
}) => {
  const [leftConstraint, setLeftConstraint] = useState<number>(0);

  useEffect(() => {
    const updateConstraints = () => {
      if (window.innerWidth <= 800) {
        setLeftConstraint(
          10 +
            mediaDetails?.result?.recommendations?.results.length * 150 +
            mediaDetails?.result?.recommendations?.results.length * 10 +
            mediaDetails?.result?.recommendations?.results.length * 1 -
            windowWidth
        );
      } else {
        setLeftConstraint(
          window.innerWidth * 0.05 +
            mediaDetails?.result?.recommendations?.results.length * 150 +
            mediaDetails?.result?.recommendations?.results.length * 10 +
            mediaDetails?.result?.recommendations?.results.length * 1 -
            windowWidth
        );
      }
    };

    updateConstraints();
    window.addEventListener("resize", updateConstraints);

    return () => {
      window.removeEventListener("resize", updateConstraints);
    };
  }, [windowWidth, mediaDetails]);
  return (
    <div className={classes.carousel_container}>
      <motion.div
        className={classes.section_card}
        style={{
          gridTemplateColumns: `repeat(${mediaDetails?.result?.recommendations?.results.length}, 150px)`,
        }}
        drag="x"
        dragConstraints={{
          top: 0,
          left: -leftConstraint,
          right: 0,
          bottom: 0,
        }}
        transition={{
          type: "spring",
          damping: 100,
          stiffness: 100,
        }}
      >
        {mediaDetails?.result?.recommendations?.results?.map(
          (data: any, idx: number) => {
            return <MovieCard key={`${idx}`} data={data} navigateTo={type} />;
          }
        )}
      </motion.div>
    </div>
  );
};

export default MediaRecommendations;
